module.exports = __webpack_public_path__ + "static/media/ic-location-black.095d0fde.svg";